import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

interface BentoGridProps {
  children: React.ReactNode;
  columns?: number;
  gap?: number;
}

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

const BentoGrid: React.FC<BentoGridProps> = ({
  children,
  columns = 4,
  gap = 3,
}) => {
  return (
    <Box
      component={motion.div}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: `repeat(${Math.min(columns, 3)}, 1fr)`,
          lg: `repeat(${columns}, 1fr)`,
        },
        gap: { xs: 1.5, sm: 2, md: gap },
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
};

export default BentoGrid;
